export enum EFileType {
  Pdf = 'application/pdf',
  Img = 'image/png'
}
